/**
 * 创建一个节流函数, N秒内的只会执行第一次
 * @param func - 需要节流的函数
 * @param delay - 延迟时间（毫秒）
 * @returns 节流后的函数
 */
/**
 * 节流函数类型定义，支持具体的参数类型
 */
export function throttle<Args extends unknown[], R>(
  func: (...args: Args) => R,
  delay: number
): (...args: Args) => R | void {
  let lastTime = 0;
  let timeoutId: NodeJS.Timeout | null = null;

  return function (this: unknown, ...args: Args): R | void {
    const now = Date.now();
    const remaining = delay - (now - lastTime);

    if (remaining <= 0) {
      if (timeoutId) {
        clearTimeout(timeoutId);
        timeoutId = null;
      }
      lastTime = now;
      return func.apply(this, args);
    }
  };
}
